import { Address } from "../product/address.model";

export interface CustomerResponse {
  id: string,
  username: string,
  email: string,
  is_email_verified: boolean,
  full_name: string,
  phone: string,
  is_phone_verified: boolean,
  has_password: boolean,
  language: string,
  is_guest: boolean,
  is_deleted: boolean,
  is_suspended: boolean,
  is_staff: boolean,
  cached_user_role: string,

}

export interface Customer extends CustomerAddressResponse {
  id: string;
  username: string,
  email: string,
  full_name: string,
}

export interface CustomerAddressResponse {
  customerAddresses: CustomerAddress[];
}

export interface OneCustomerAddressResponse {
  customerAddress: CustomerAddress;
}

export interface CustomerAddress extends Address {
  id?: number;
  isDefault: boolean;
  customerId: number;
  recipientName: string;
  contactNumber: string;
  contactCountryCode: string;
  addressTitle: string;
  note?: string
}

//  new 

export interface AddressResponse {
  id: number;
  address_line_1: string;
  address_line_2?: string;
  city: string;
  state?: string;
  country: string;
  is_mobile_verified: boolean;
  address_associated_with: string; // e.g., "customer", "order", etc.
  first_name: string;
  last_name?: string;
  latitude: number;
  longitude: number;
  email: string;
  mobile: string;
  note: string | null; // Can be null if no note
  is_default: boolean;
}
export interface AddressListResponse {
  records: AddressResponse[];
}

export interface emitInput {
  address: AddressResponse;
  type: string;
}

export interface TranslationMap {
  en: string;
  ar: string;
}
export interface AreaResponse {
  id: number;
  name: string;
  translations: TranslationMap;
  city_id: number;
}
export interface CityResponse {
  id: number;
  name: string;
  translations: TranslationMap;
  createdAt: string;   // ISO date string
  updatedAt: string;   // ISO date string
  areas: AreaResponse[];
}
export interface CityListResponse  {
  records: CityResponse[];
}

export interface AreaFilterResponse {
  id: number;
  nameEn: string;
  nameAr: string;
  cityId: number;
}
export interface EmirateOption {
  id: number;
  value: string;
  trValue?: string;
  label: string;
}
